module.exports = __webpack_public_path__ + "8a6ee7dd3ca66a9e04c52d721f321bd4.MP3";